@let propertyTypes = propertyTypes$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Walking Farm&#174; Filters</ion-title>
    <ion-buttons slot="primary">
      <ion-button (click)="clearFilters()">
        Clear <ion-icon slot="end" name="backspace-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</red-header-content>
<red-page-content [paddingBottom]="true" class="no-last-line">
  <form [formGroup]="filterForm">
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>Owner Status</ion-label>
      </ion-list-header>
      <ion-radio-group formControlName="filterByOwnerOccupied">
        <ion-item> <ion-radio [value]="null">All</ion-radio></ion-item>
        <ion-item> <ion-radio value="Y">Owner Occupied</ion-radio></ion-item>
        <ion-item> <ion-radio value="N">Non Owner Occupied</ion-radio></ion-item>
      </ion-radio-group>
    </ion-list>
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>No Sales Within</ion-label>
      </ion-list-header>
      <ion-item>
        <ion-label>
          {{
            filterForm.controls.filterByNoSalesWithinYears.getRawValue() === 0
              ? 'Any sale date'
              : filterForm.controls.filterByNoSalesWithinYears.getRawValue() > 1
                ? filterForm.controls.filterByNoSalesWithinYears.getRawValue() + ' years'
                : filterForm.controls.filterByNoSalesWithinYears.getRawValue() + ' year'
          }}
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-range
          formControlName="filterByNoSalesWithinYears"
          [pin]="true"
          [step]="1"
          aria-label="No Sales Within"
          [min]="0"
          [max]="30"
        >
          <ion-button slot="start" shape="round" fill="outline" (click)="updateFilterByNoSalesWithinYears(false)">
            <ion-icon slot="icon-only" name="remove-outline"></ion-icon>
          </ion-button>

          <ion-button slot="end" shape="round" fill="outline" (click)="updateFilterByNoSalesWithinYears(true)">
            <ion-icon slot="icon-only" name="add-outline"></ion-icon>
          </ion-button>
        </ion-range>
      </ion-item>
    </ion-list>
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>Property Type</ion-label>
      </ion-list-header>
      <ion-item>
        @if (filterForm.controls.filterByPropertyType.getRawValue()?.length) {
          <ion-label color="warning">
            @for (
              filterByPropertyTypeItem of filterForm.controls.filterByPropertyType.getRawValue();
              track filterByPropertyTypeItem;
              let last = $last
            ) {
              <span class="tw:text-xs tw:font-bold"> {{ filterByPropertyTypeItem.label }}{{ last ? '' : ', ' }} </span>
            }
          </ion-label>
        } @else {
          <ion-label color="medium"> <span class="tw:text-xs">Any types</span> </ion-label>
        }
      </ion-item>
      @if (propertyTypes) {
        <ion-item>
          <ion-select
            formControlName="filterByPropertyType"
            [compareWith]="comparePropertyTypes"
            aria-label="Property Types"
            selectedText="Please select"
            justify="end"
            interface="modal"
            toggleIcon="arrow-forward-circle-outline"
            [interfaceOptions]="{ header: 'Select property types' }"
            [multiple]="true"
          >
            @for (propertyType of propertyTypes; track propertyType) {
              <ion-select-option [value]="propertyType">
                {{ propertyType.label }}
              </ion-select-option>
            }
          </ion-select>
        </ion-item>
      }
    </ion-list>
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>Bathrooms</ion-label>
      </ion-list-header>
      <ion-item>
        <ion-label>
          {{
            filterForm.controls.filterByBathroomsNumber.getRawValue()
              | redRangeFilterText
                : { labelDefault: 'Any number', labelSingular: 'bathroom', labelPlural: 'bathrooms', max: 5, min: 0 }
          }}
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-range
          formControlName="filterByBathroomsNumber"
          [pin]="true"
          aria-label="Bathrooms Number"
          [min]="0"
          [max]="5"
          [snaps]="true"
          [step]="1"
          [dualKnobs]="true"
        >
          <span slot="start">0</span>
          <span slot="end">5+</span>
        </ion-range>
      </ion-item>
    </ion-list>
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>Bedrooms</ion-label>
      </ion-list-header>
      <ion-item>
        <ion-label>
          {{
            filterForm.controls.filterByBedroomsNumber.getRawValue()
              | redRangeFilterText
                : { labelDefault: 'Any number', labelSingular: 'bedroom', labelPlural: 'bedrooms', max: 5, min: 0 }
          }}
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-range
          formControlName="filterByBedroomsNumber"
          [pin]="true"
          aria-label="Bedrooms Number"
          [min]="0"
          [max]="5"
          [snaps]="true"
          [step]="1"
          [dualKnobs]="true"
        >
          <span slot="start">0</span>
          <span slot="end">5+</span>
        </ion-range>
      </ion-item>
    </ion-list>
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>Living Area</ion-label>
      </ion-list-header>
      <ion-item>
        <ion-label>
          {{
            filterForm.controls.filterByLivingArea.getRawValue()
              | redRangeFilterText
                : { labelDefault: 'Any SqFt', labelSingular: 'SqFt', labelPlural: 'SqFt', max: 5000, min: 0 }
          }}
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-range
          formControlName="filterByLivingArea"
          [pin]="true"
          aria-label="Living Area"
          [min]="0"
          [max]="5000"
          [dualKnobs]="true"
        >
          <span slot="start">0</span>
          <span slot="end">5000+</span>
        </ion-range>
      </ion-item>
    </ion-list>
  </form>
</red-page-content>
